import { useQuery, UseQueryOptions } from "react-query";
import { IPhraseTrigger, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { getAllPaginatedItems } from "utilities/get-all-paginated-items";

/**
 * Request the phrase triggers from the backend.
 * @param url             The URL to get the phrase triggers.
 * @param queryParameters Any query parameters to be added to the request.
 * @returns An array of phrase triggers.
 */
const requestPhraseTriggers = async (url: string, queryParameters: {}) => {
    const data = await getAllPaginatedItems<IPhraseTrigger>(url, { params: queryParameters });
    return data.sort((one, two) => one.phrase.localeCompare(two.phrase));
};

/**
 * A query to get phrase triggers from the backend.
 * @param queryParameters Any query parameters to be added to the request.
 * @param options         Options to be passed to the query.
 */
const usePhraseTriggers = <T = IPhraseTrigger[]>(
    queryParameters: {} = {},
    options: Omit<UseQueryOptions<IPhraseTrigger[], AxiosError, T>, "queryKey" | "queryFn"> = {}
) => {
    const url = Route.PhraseTriggers;
    return useQuery<IPhraseTrigger[], AxiosError, T>(
        [url, queryParameters],
        () => requestPhraseTriggers(url, queryParameters),
        options
    );
};

export default usePhraseTriggers;
